import React from 'react';
import { Button, Modal } from 'antd-mobile';
import { URLS, jumpToH5 } from '../utils';

export default ({ rewardsList, t }) => {
	const handleClose = () => {
		// 关闭弹窗
		modal.close();
	};
	const handleToLink = () => {
		// 跳转到兑换记录
		modal.close();
		const url = URLS.Coupon[process.env.REACT_APP_ENV];
		jumpToH5(
			url,
			{
				_app_fullScreen: 'y',
			},
			{
				isToTransferPage: true,
			},
		);
	};

	const modal = Modal.show({
		content: (
			<div className='rc-alert'>
				<div className='rc-alert-bd'>
					<p>{t('redeem.popup_1')}</p>
					{rewardsList.map((item) => (
						<p>
							<span style={{ color: '#F53B3A' }}>· {item} ·</span>
						</p>
					))}
					<p>
						<span style={{ color: 'rgba(0,0,0,.28)', fontSize: 12 }}>
							{t('redeem.popup_view_Rewards')}
						</span>
					</p>
				</div>
				<div className='rc-alert-ft'>
					<Button className='rc-alert-btn rc-alert-btn--orange' onClick={handleToLink}>
						{t('redeem.popup_use')}
					</Button>
					<Button className='rc-alert-btn' onClick={handleClose}>
						{t('redeem.popup_iKnow')}
					</Button>
				</div>
			</div>
		),
		closeOnMaskClick: true,
	});
};
